
<div class="pae-box" [class.mobile-pae-box]="isMobilePae">
  <!-- <span class="pae-x-label">Scored residue</span>
  <span class="pae-y-label">Aligned residue</span> -->
  <div class="pae-axis-box pae-axis-box-{{paeid}} pae-axis-box"></div>
  <div class="pae-img-box pae-img-box-{{paeid}}">
    <div class="pae-img-box-border">
      <div id="{{paeid}}" style="aspect-ratio: 1;"></div>
    </div>
  </div>
  <img alt="paescale" class="pae-scale-img-h" src="../../assets/img/horizontal_colorbar.png" width="256" height="1">
  <ul class="pae-scale-ticks-h">
    <li>0</li>
    <li>5</li>
    <li>10</li>
    <li>15</li>
    <li>20</li>
    <li>25</li>
    <li>30</li>
  </ul>
  <span class="pae-scale-label">Expected position error (&Aring;ngstr&ouml;ms)</span>
</div>

<div class="paetitle-container">
  <span class="pae-title">Predicted Aligned Error (PAE)</span>
  <span class="pae-desc">PAE measures the confidence in the relative position of two residues 
    <span class="hideOnMobile">
      - <b>see Help section below</b> for more information.
    </span>
  </span>
</div>
